import { InjectionToken } from '@angular/core';
import type { ItemDialogContext } from './models/event.models';

export const ITEM_DIALOG_CONTEXT = new InjectionToken<ItemDialogContext>(
  'ITEM_DIALOG_CONTEXT'
);
